jQuery(function($) {

  console.log("Quiz loaded!")

    function insertAfter(referenceNode, newNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }

    //RANDOMLY SORT PRODUCT BLOCKS ON RESULT PAGE
    const randomiseFlexOrder = querySelector => {
      [...querySelector].map((c,i,a) => c.style.order = Math.floor(Math.random() * a.length + 1));
    };

    const products = [["All Products","https://www.westcoastseeds.com/collections/vegetable-seeds"],["Cucamelon", "https://www.westcoastseeds.com/products/cucamelon"], ["Rainbow Blend", "https://www.westcoastseeds.com/products/rainbow-blend"]];
    const productsObj = [
      {
        collectionHandle: "sprouting",
        links:[
          ["All Sprouting Products","https://www.westcoastseeds.com/collections/sprouting"],
          ["Sprouting Jar with Metal Lid and Seeds", "https://www.westcoastseeds.com/products/sprouting-jar-metal-lid-seeds"],
          ["Sandwich Booster Mix Organic", "https://www.westcoastseeds.com/products/special-mix-organic"],
          ["Alfalfa Sprouting Seeds Organic", "https://www.westcoastseeds.com/products/alfalfa-sprouting-seeds-organic"],
          ["Red Radish Organic", "https://www.westcoastseeds.com/products/red-radish-organic"],
          ["Go Go Sprouting Seeds Organic", "https://www.westcoastseeds.com/products/a-go-go-sprouting-seeds-organic"]
        ]
      },
      {
        collectionHandle: "kale-seeds",
        links:[
          ["All Kale Products","https://www.westcoastseeds.com/collections/kale-seeds"],
          ["Rainbow Lacinato Organic", "https://www.westcoastseeds.com/products/rainbow-tuscan-organic"], 
          ["Red Russian", "https://www.westcoastseeds.com/products/red-russian"],
          ["Winterbor ", "https://www.westcoastseeds.com/products/winterbor"],
          ["Darkibor Coated", "https://www.westcoastseeds.com/products/darkibor"],
          ["Lacinato Organic ", "https://www.westcoastseeds.com/products/lacinato-organic"]
        ]
      },
      {
        collectionHandle: "tomato-seeds",
        links:[
          ["All Tomato Products","https://www.westcoastseeds.com/collections/tomato-seeds"],
          ["Indigo Rose Organic", "https://www.westcoastseeds.com/products/indigo-rose-organic"],
          ["Sakura Organic", "https://www.westcoastseeds.com/products/sakura-organic"],
          ["Black Krim Organic", "https://www.westcoastseeds.com/products/black-krim-organic"],
          ["Tumbler", "https://www.westcoastseeds.com/products/tumbler-tomato-seeds"],
          ["Early Girl", "https://www.westcoastseeds.com/products/early-girl"]
        ]
      },
      {
        collectionHandle: "microgreens-seeds",
        links:[
          ["All Microgreen Products","https://www.westcoastseeds.com/collections/microgreens-seeds"],
          ["SunBlaster T5HO Mini Greenhouse Kit", "https://www.westcoastseeds.com/products/mini-greenhouse-indoor-growing-kit"],
          ["Microgreen Pea Shoots", "https://www.westcoastseeds.com/products/microgreen-pea-shoot-seeds"],
          ["Microgreen Mustard Seeds", "https://www.westcoastseeds.com/products/microgreen-mustard-seeds"],
          ["Two Week Microgreen Seeds", "https://www.westcoastseeds.com/products/two-week-microgreen-seeds"],
          ["SunBlaster T5H0 Growlight Garden", "https://www.westcoastseeds.com/products/growlight-garden-5"]
        ]
      },
      {
        collectionHandle: "cucumber-seeds",
        links:[
          ["All Cucumber Products","https://www.westcoastseeds.com/collections/cucumber-seeds"],
          ["Patio Snacker", "https://www.westcoastseeds.com/products/patio-snacker"],
          ["Mercury Cucumber", "https://www.westcoastseeds.com/products/mercury"],
          ["Tasty Green Cucumber", "https://www.westcoastseeds.com/products/tasty-green"],
          ["Cucuamelon", "https://www.westcoastseeds.com/products/cucamelon"],
          ["Tyria Organic", "https://www.westcoastseeds.com/products/tyria-organic"]
        ]
      },
      {
        collectionHandle: "mustard-seeds",
        links:[
          ["All Mustard Green Products","https://www.westcoastseeds.com/collections/mustard-seeds"],
          ["Osaka Purple", "https://www.westcoastseeds.com/products/osaka-purple"],
          ["Stir Fry Blend", "https://www.westcoastseeds.com/products/stir-fry"],
          ["Mizuna Organic", "https://www.westcoastseeds.com/products/mizuna-organic"],
          ["Komatsuna Green", "https://www.westcoastseeds.com/products/komatsuna-green"],
          ["Tokyo Bekana", "https://www.westcoastseeds.com/products/tokyo-bekana-mustard-seeds"]
        ]
      },
      {
        collectionHandle: "carrot-seeds",
        links:[
          ["All Carrot Products","https://www.westcoastseeds.com/collections/vegetable-seeds"],
          ["Rainbow Blend", "https://www.westcoastseeds.com/products/rainbow-blend"],
          ["Bolero", "https://www.westcoastseeds.com/products/bolero"],
          ["Ya Ya Coated Organic", "https://www.westcoastseeds.com/products/ya-ya-organic"],
          ["Deep Purple Coated", "https://www.westcoastseeds.com/products/deep-purple"],
          ["Royal Chantenay", "https://www.westcoastseeds.com/products/royal-chantenay"]
        ]
      },
      {
        collectionHandle: "arugula-seeds",
        links:[
          ["All Arugula Products","https://www.westcoastseeds.com/collections/arugula-seeds"],
          ["Astro Organic", "https://www.westcoastseeds.com/products/astro-organic"],
          ["Dragon’s Fire", "https://www.westcoastseeds.com/products/dragons-fire"],
          ["Bellezia Organic", "https://www.westcoastseeds.com/products/bellezia-organic"],
          ["Selvatica Organic", "https://www.westcoastseeds.com/products/selvatica-organic"],
          ["Alfresco Pelleted", "https://www.westcoastseeds.com/products/alfresco"]
        ]
      },
      {
        collectionHandle: "squash-seeds",
        links:[
          ["All Squash Products","https://www.westcoastseeds.com/collections/squash-seeds"],
          ["Sunburst", "https://www.westcoastseeds.com/products/sunburst"],
          ["First Taste Kabocha", "https://www.westcoastseeds.com/products/first-taste-kabocha"],
          ["Table Queen", "https://www.westcoastseeds.com/products/table-queen"],
          ["Tiana Butternut Organic", "https://www.westcoastseeds.com/products/tiana-butternut"],
          ["Tromboncino", "https://www.westcoastseeds.com/products/tromboncino"]
        ]
      },
      {
        collectionHandle: "bush-beans",
        links:[
          ["All Bush Bean Products","https://www.westcoastseeds.com/collections/bush-beans"],
          ["Celine Certified Organic", "https://www.westcoastseeds.com/products/celine-certified-organic"],
          ["Goliath", "https://www.westcoastseeds.com/products/goliath-f26"],
          ["Gold Rush", "https://www.westcoastseeds.com/products/gold-rush-2"],
          ["Tricolour Bean Blend", "https://www.westcoastseeds.com/products/tricolor-bean-blend"],
          ["Masai Bush Bean", "https://www.westcoastseeds.com/products/masai-french"]
        ]
      },
      {
        collectionHandle: "pole-beans",
        links:[
          ["All Bush Bean Products","https://www.westcoastseeds.com/collections/pole-beans"],
          ["Kentucky Blue", "https://www.westcoastseeds.com/products/kentucky-blue"],
          ["Fortex Filet", "https://www.westcoastseeds.com/products/fortex-filet"],
          ["Matilda", "https://www.westcoastseeds.com/products/matilda"],
          ["Blue Lake", "https://www.westcoastseeds.com/products/blue-lake"],
          ["Purple Peacock", "https://www.westcoastseeds.com/products/purple-peacock"]
        ]
      },
      {
        collectionHandle: "swiss-chard-seeds",
        links:[
          ["All Swiss Chard Products","https://www.westcoastseeds.com/collections/swiss-chard-seeds"],
          ["Magenta Sunset", "https://www.westcoastseeds.com/products/magenta-sunset"],
          ["Peppermint Chard", "https://www.westcoastseeds.com/products/peppermint"],
          ["Rhubarb Chard", "https://www.westcoastseeds.com/products/rhubarb-chard"],
          ["Silverado", "https://www.westcoastseeds.com/products/silverado"],
          ["Canary Yellow", "https://www.westcoastseeds.com/products/canary-yellow"]
        ]
      },
      {
        collectionHandle: "turnip-seeds",
        links:[
          ["All Turnip Products","https://www.westcoastseeds.com/collections/turnip-seeds"],
          ["Hakurei", "https://www.westcoastseeds.com/products/hakurei"],
          ["Purple Top White Globe", "https://www.westcoastseeds.com/products/purple-top-white-globe"],
          ["Silky Sweet", "https://www.westcoastseeds.com/products/silky-sweet"],
          ["Tokyo Cross", "https://www.westcoastseeds.com/products/tokyo-cross"],
          ["Purple Prince", "https://www.westcoastseeds.com/products/purple-prince"]
        ]
      },
      {
        collectionHandle: "corn-seeds",
        links:[
          ["All Corn Products","https://www.westcoastseeds.com/collections/corn-seeds"],
          ["Golden Bantam", "https://www.westcoastseeds.com/products/golden-bantam"],
          ["Jubilee Super Sweet", "https://www.westcoastseeds.com/products/jubilee-super-sweet"],
          ["Calico Popcorn", "https://www.westcoastseeds.com/products/calico-popcorn"],
          ["Glass Gem Organic", "https://www.westcoastseeds.com/products/glass-gem-organic"],
          ["Pink Popcorn", "https://www.westcoastseeds.com/products/pink-popcorn"]
        ]
      },
      {
        collectionHandle: "artichoke-seeds",
        links:[
          ["All Artichoke Products","https://www.westcoastseeds.com/collections/artichoke-seeds"],
          ["Imperial Star Organic", "https://www.westcoastseeds.com/products/imperial-star-organic-2"],
          ["Cardoon", "https://www.westcoastseeds.com/products/cardoon-2"],
          ["Green Globe", "https://www.westcoastseeds.com/products/green-globe"]
        ]
      },
      {
        collectionHandle: "pepper-seeds",
        links:[
          ["All Pepper Products","https://www.westcoastseeds.com/collections/pepper-seeds"],
          ["Red Candy Cane", "https://www.westcoastseeds.com/products/red-candy-cane"],
          ["Mad Hatter", "https://www.westcoastseeds.com/products/mad-hatter"],
          ["Purple Beauty", "https://www.westcoastseeds.com/products/purple-beauty"],
          ["Oranos Organic", "https://www.westcoastseeds.com/products/oranos-organic"],
          ["Orange You Sweet", "https://www.westcoastseeds.com/products/orange-you-sweet"]
        ]
      },
      {
        collectionHandle: "hot-peppers",
        links:[
          ["All Hot Pepper Products","https://www.westcoastseeds.com/collections/hot-peppers"],
          ["Spicy Slice", "https://www.westcoastseeds.com/products/spicy-slice"],
          ["Trinidad Morunga Scorpion", "https://www.westcoastseeds.com/products/trinidad-moruga-scorpion"],
          ["Pepperoncini", "https://www.westcoastseeds.com/products/pepperoncini"],
          ["Large Thick Cayenne", "https://www.westcoastseeds.com/products/large-cayenne"],
          ["Habanero", "https://www.westcoastseeds.com/products/habanero"]
        ]
      },
      {
        collectionHandle: "melon-seeds",
        links:[
          ["All Melon Products","https://www.westcoastseeds.com/collections/melon-seeds"],
          ["Tirreno Organic", "https://www.westcoastseeds.com/products/tirreno-organic"],
          ["Divergent Organic", "https://www.westcoastseeds.com/products/divergent-organic"],
          ["Black Beauty Mini Watermelon", "https://www.westcoastseeds.com/products/black-beauty-mini-watermelon"],
          ["Yellow Doll", "https://www.westcoastseeds.com/products/yellow-doll"],
          ["Home Run", "https://www.westcoastseeds.com/products/home-run"]
        ]
      },
      {
        collectionHandle: "strawberry-seeds",
        links:[
          ["All Strawberry Products","https://www.westcoastseeds.com/collections/strawberry-seeds"],
          ["Yellow Wonder Alpine", "https://www.westcoastseeds.com/products/yellow-wonder-alpine"],
          ["Fresca Strawberry", "https://www.westcoastseeds.com/products/fresca-strawberry-seeds"],
          ["Regina", "https://www.westcoastseeds.com/products/regina"]
        ]
      },
      {
        collectionHandle: "asparagus-seeds",
        links:[
          ["All Asparagus Products","https://www.westcoastseeds.com/collections/asparagus-seeds"],
          ["Guelph Millennium", "https://www.westcoastseeds.com/products/guelph-millennium"],
          ["Voltaire Asparagus", "https://www.westcoastseeds.com/products/voltaire-asparagus"]
        ]
      },
      {
        collectionHandle: "eggplant-seeds",
        links:[
          ["All Eggplant Products","https://www.westcoastseeds.com/collections/eggplant-seeds"],
          ["Ping Tung Long", "https://www.westcoastseeds.com/products/ping-tung-long"],
          ["Piccolo", "https://www.westcoastseeds.com/products/piccolo"],
          ["Listada de Grandia Organic", "https://www.westcoastseeds.com/products/listada-de-gandia-certified-organic"],
          ["Traviata Organic", "https://www.westcoastseeds.com/products/traviata-organic"],
          ["Long Purple", "https://www.westcoastseeds.com/products/fingerling-long-purple"]
        ]
      },
      {
        collectionHandle: "lettuce-seeds",
        links:[
          ["All Lettuce Products","https://www.westcoastseeds.com/collections/lettuce-seeds"],
          ["Buttercrunch", "https://www.westcoastseeds.com/products/buttercrunch"],
          ["Red Salad Bowl", "https://www.westcoastseeds.com/products/red-salad-bowl"],
          ["Drunken Woman Lettuce Organic", "https://www.westcoastseeds.com/products/drunken-woman-lettuce-organic"],
          ["Simpson Elite", "https://www.westcoastseeds.com/products/simpson-elite"],
          ["Speckled Butterhead Organic", "https://www.westcoastseeds.com/products/speckled-butterhead-organic"]
        ]
      },
      {
        collectionHandle: "herb-seeds",
        links:[
          ["All Herbs Products","https://www.westcoastseeds.com/collections/herb-seeds"],
          ["Sweet Basil", "https://www.westcoastseeds.com/products/sweet-basil"],
          ["Genovese Organic", "https://www.westcoastseeds.com/products/genovese-organic"],
          ["Piccolino Organic", "https://www.westcoastseeds.com/products/piccolino-organic"],
          ["Forest Green Parsley", "https://www.westcoastseeds.com/products/forest-green"],
          ["Santo Organic", "https://www.westcoastseeds.com/products/santo-organic"]
        ]
      },
      {
        collectionHandle: "pea-seeds",
        links:[
          ["All Pea Products","https://www.westcoastseeds.com/collections/pea-seeds"],
          ["Super Sugar Snap", "https://www.westcoastseeds.com/products/super-sugar"],
          ["Alderman Tall Telephone", "https://www.westcoastseeds.com/products/alderman-tall-telephone"],
          ["Purple Mist Organic", "https://www.westcoastseeds.com/products/blue-delft"],
          ["Green Arrow", "https://www.westcoastseeds.com/products/green-arrow"],
          ["Dwarf Grey Sugar", "https://www.westcoastseeds.com/products/dwarf-grey-sugar"]
        ]
      },
      {
        collectionHandle: "cabbage-seeds",
        links:[
          ["All Cabbage Products","https://www.westcoastseeds.com/collections/pea-seeds"],
          ["Integro Organic", "https://www.westcoastseeds.com/products/integro-organic"],
          ["Tiara Coated", "https://www.westcoastseeds.com/products/tiara"],
          ["Deadon Coated Organic", "https://www.westcoastseeds.com/products/deadon"],
          ["Kalibos", "https://www.westcoastseeds.com/products/kalibos"],
          ["Consul", "https://www.westcoastseeds.com/products/consul"]
        ]
      },
      {
        collectionHandle: "cilantro-seeds",
        links:[
          ["All Cilantro Products","https://www.westcoastseeds.com/collections/cilantro-seeds"],
          ["Santo Organic", "https://www.westcoastseeds.com/products/santo-organic"],
          ["Calypso", "https://www.westcoastseeds.com/products/calypso"],
          ["Santo Long Standing", "https://www.westcoastseeds.com/products/santo-long-standing"]
        ]
      },
      {
        collectionHandle: "chive-seeds",
        links:[
          ["All Chive Products","https://www.westcoastseeds.com/collections/chive-seeds"],
          ["Chives", "https://www.westcoastseeds.com/products/chives"],
          ["Chives Organic", "https://www.westcoastseeds.com/products/chives-organic"],
          ["Lion’s Mane", "https://www.westcoastseeds.com/products/lions-mane"],
          ["Garlic Chives", "https://www.westcoastseeds.com/products/garlic-chives"]
        ]
      },
      {
        collectionHandle: "cress-seeds",
        links:[
          ["All Watercress Products","https://www.westcoastseeds.com/collections/cress-seeds"],
          ["True Watercress", "https://www.westcoastseeds.com/products/watercress"],
          ["Curly Cress Peppergrass", "https://www.westcoastseeds.com/products/peppergrass-curly-cress"]
        ]
      },
      {
        collectionHandle: "onion-seeds",
        links:[
          ["All Onion Products","https://www.westcoastseeds.com/collections/onion-seeds"],
          ["Patterson", "https://www.westcoastseeds.com/products/patterson"],
          ["Zebrune", "https://www.westcoastseeds.com/products/zebrune"],
          ["Cabernet", "https://www.westcoastseeds.com/products/cabernet-organic"],
          ["Borettana", "https://www.westcoastseeds.com/products/borettana"],
          ["Kelsae", "https://www.westcoastseeds.com/products/kelsae"]
        ]
      },
      {
        collectionHandle: "cauliflower-seeds",
        links:[
          ["All Cauliflower Products","https://www.westcoastseeds.com/collections/cauliflower-seeds"],
          ["Skywalker Organic", "https://www.westcoastseeds.com/products/skywalker-organic"],
          ["Sunset", "https://www.westcoastseeds.com/products/sunset"],
          ["Adona F1 Organic", "https://www.westcoastseeds.com/products/adona-f1-coated-certified-organic"],
          ["Amazing", "https://www.westcoastseeds.com/products/amazing-cauliflower-seeds"],
          ["Walcheren Winter", "https://www.westcoastseeds.com/products/walcheren-winter"]
        ]
      }
    ]

    //RUN ON RESULTS PAGE
    document.addEventListener('octane.quiz.completed', function (e) {
        // your code for building and handling the results page
        handleResults();
      }, false);

    window.onload = function(){ 
      if (document.querySelectorAll('.oct-quiz-wrapper--result-page').length > 0) {
        console.log('landed directly on results?')
        handleResults();
      }
    }
    
    function handleResults() {
       //randomize order
       randomiseFlexOrder(document.querySelectorAll('.oct-quiz-product-block'));
       //create product dropdowns
       let clickedCollections = [];
       const collectionLinks = document.querySelectorAll('.oct-quiz-product-block a');
       for (let i = 0; i < collectionLinks.length; i++) {
         collectionLinks[i].addEventListener("click", function(e) {
           e.preventDefault();
           console.log('Collection Clicked: ', collectionLinks[i].href);
           if (!clickedCollections.includes(collectionLinks[i].href)) {
             clickedCollections.push(collectionLinks[i].href);
             var urlParts = collectionLinks[i].href.split('/');
             var currentHandle = urlParts[urlParts.length - 1];
             console.log(currentHandle);
             var targetProducts = productsObj.find(function(collection, index) {
               if(collection.collectionHandle == currentHandle)
                 return true;
             });
             var ul = document.createElement("ul");
             ul.classList.add('product-drop');
             if (targetProducts) {
               for (let p = 0; p <= targetProducts.links.length - 1; p++) {
                 var li = document.createElement('li');
                 var prodLink = document.createElement('a');
                 prodLink.href = targetProducts.links[p][1];
                 prodLink.innerHTML = targetProducts.links[p][0];
                 prodLink.setAttribute('target', '_blank');
                 li.appendChild(prodLink);
                 ul.appendChild(li);     // append li to ul.
             }
             } else {
               for (let p = 0; p <= products.length - 1; p++) {
                 var li = document.createElement('li');
                 var prodLink = document.createElement('a');
                 prodLink.href = products[p][1];
                 prodLink.innerHTML = products[p][0];
                 li.appendChild(prodLink);
                 ul.appendChild(li);     // append li to ul.
               }
             }
             insertAfter(collectionLinks[i], ul)
           }
         });
       }
       console.log('finished quiz!');
    }
    
    //MUTATION OBSERVERS TO ADD NAME AND OTHER CUSTOM PROPERTIES INTO OCTANE SECTION CONTENT
    function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }
    let suppliedName;
    let backToQuestion = false;
    function clickBack() {
      let backButton = document.querySelector('.oct-quiz-btn--small');
      backButton.click();
    }
    function backToPriorQuestion() {
      if (backToQuestion) {
        let backButton = document.querySelector('.oct-quiz-btn--small');
        backButton.click();
      }
    }
    
    // waitForElm('.oct-quiz-wrapper--collect-text .oct-quiz-btn--primary').then((elm) => {
    //     watchOctaneChanges(elm)
    // });
    function watchOctaneChanges(element) {
      console.log('Name input is ready');
      let nameInput = document.querySelector('.oct-quiz-collect-text-wrapper input');
      element.addEventListener("click", function() {
         suppliedName = nameInput.value;
         console.log('captured username: ', suppliedName);
      });
      waitForElm('.oct-quiz-wrapper--explainer').then((elm2) => {
        insertUserName(elm2);
      });
    }
    function insertUserName(element) {
      console.log('Name explainer section up') ;
      let nameTitle = element.querySelector('.oct-quiz-title');
      if (suppliedName && !nameTitle.textContent.includes(suppliedName)) {
        nameTitle.textContent = suppliedName + ", " + nameTitle.textContent.toLocaleLowerCase();
      }
    }

    var explainerObserver = new MutationObserver(function(mutations) {
      let explainerWrapper = document.querySelector('.oct-quiz-wrapper--explainer');
      let pictureQWrapper = document.querySelector('.oct-quiz-wrapper--picture-choice');
      if (explainerWrapper != null) {
          console.log("explainer section up");
          let nameTitle = document.querySelector('.oct-quiz-title');
          if (nameTitle.textContent.toLocaleLowerCase().includes("true gardener's name")) {
            console.log('name title section...inserting name');
            backToQuestion = false;
            if (suppliedName && !nameTitle.textContent.includes(suppliedName)) {
              nameTitle.textContent = suppliedName + ", " + nameTitle.textContent.toLocaleLowerCase();
            }
          } else if (nameTitle.textContent.toLocaleLowerCase().includes("going anonymous")) {
            console.log('name input skipped...going anon');
            backToQuestion = false;
          } else if (backToQuestion) {
            clickBack();
          } else if (document.querySelectorAll('.auto-loader').length < 1) {
            console.log('assuming comment section...adding loader');
            let autoLoader = document.createElement('div');
            autoLoader.classList.add('auto-loader');
            insertAfter(nameTitle, autoLoader);
          }
          // newObserver.disconnect();
          //We can disconnect observer once the element exist if we dont want observe more changes in the DOM
      } else if (pictureQWrapper != null) {
        console.log("question section up");
        backToQuestion = false;
        //listen for back button
        document.querySelector('.oct-quiz-btn--small').addEventListener('click', function() {
          console.log('back clicked!');
          backToQuestion = true;
        })
      }
    });
    // Start observing
    explainerObserver.observe(document.body, { //document.body is node target to observe
        childList: true, //This is a must have for the observer with subtree
        subtree: true //Set to true if changes must also be observed in descendants.
    });

    var nameInputObserver = new MutationObserver(function(mutations) {
      let continueButton = document.querySelector('.oct-quiz-wrapper--collect-text .oct-quiz-btn--primary');
      if (continueButton != null) {
          console.log("Name input is ready");
          let nameInput = document.querySelector('.oct-quiz-collect-text-wrapper input');
          let continueButton = document.querySelector('.oct-quiz-wrapper--collect-text .oct-quiz-btn--primary');
          continueButton.addEventListener("click", function() {
             suppliedName = nameInput.value;
             console.log('captured username: ', suppliedName);
          });
          // newObserver.disconnect();
          //We can disconnect observer once the element exist if we dont want observe more changes in the DOM
      }
    });
    // Start observing
    nameInputObserver.observe(document.body, { //document.body is node target to observe
        childList: true, //This is a must have for the observer with subtree
        subtree: true //Set to true if changes must also be observed in descendants.
    });
})
